module.exports = __webpack_public_path__ + "img/FR19406.218c5b26.svg";